import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    meta: { title: "Home – MASH" },
    component: () =>
      import(/* webpackChunkName: "Landing" */ "../components/applicant/Landing.vue"),
  },
  {
    path: "/application/:application_id",
    meta: { title: "Application – MASH" },
    component: () =>
      import(/* webpackChunkName: "Application" */ "../components/applicant/application/Application.vue"),
  },
  {
    path: "/review/:application_id",
    meta: { title: "Application Review – MASH" },
    component: () =>
      import(/* webpackChunkName: "ReviewApplication" */ "../components/review/ApplicationReview.vue"),
  },
  {
    path: "/review/:application_id/print",
    meta: { title: "Print Application – MASH" },
   component: () =>
    import(/* webpackChunkName: "PrintApplication" */ "../components/review/PrintComponent.vue"),
  },
  {
  path: "/review/:application_id/Tuition",
  meta: { title: "Tuition Cost – MASH" },
  component: () =>
   import(/* webpackChunkName: "TuitionCost" */ "../components/review/Tuition/TuitionCost.vue"),
  },
  {
    path: "/review/:application_id/resident-tuition",
    meta: { title: "Resident Tuition – MASH" },
    component: () =>
      import(/* webpackChunkName: "ResidentTuition" */ "../components/review/Tuition/TuitionResident.vue"),
  },
  {
    path: "/admin/applications",
    meta: { title: "Applications – MASH Admin" },
    component: () =>
      import(/* webpackChunkName: "ApplicationList" */ "../components/admin/ApplicationList.vue"),
  },
  // {
  //   path: "/admin/:application_id",
  //   name: "admin-application-review",
  //   component: () =>
  //     import(/* webpackChunkName: "ReviewApplication" */ "../components/review/ApplicationReview.vue"),
  // },
  
  {
    path: "/admin/configure/service-types",
    meta: { title: "Service Types – MASH Admin" },
    component: () =>
      import(/* webpackChunkName: "ServiceTypes" */ "../components/admin/configure/ServiceTypes.vue"),
  },

  {
    path: "/admin/configure/statuses",
    meta: { title: "Status Types – MASH Admin" },
    component: () =>
      import(/* webpackChunkName: "ApplicationStatuses" */ "../components/admin/configure/StatusTypes.vue"),
  },
  {
    path: "/admin/configure/email-content",
    meta: { title: "Email Content – MASH Admin" },
    component: () =>
      import(/* webpackChunkName: "EmailContent" */ "../components/admin/configure/EmailContent.vue"),
  },
  {
    path: "/admin/configure/infotext",
    meta: { title: "Infotext – MASH Admin" },
    component: () =>
      import(/* webpackChunkName: "InfoText" */ "../components/admin/configure/InfoText.vue"),
  },
  {
    path: "/admin/configure/documents",
    meta: { title: "Document Types – MASH Admin" },
    component: () =>
      import(/* webpackChunkName: "DocumentTypes" */ "../components/admin/configure/DocumentTypes.vue"),
  },
  {
    path: "/admin/configure/benefits",
    meta: { title: "Benefit Types – MASH Admin" },
    component: () =>
      import(/* webpackChunkName: "BenefitTypes" */ "../components/admin/configure/BenefitTypes.vue"),
  },
  {
    path: "/admin/configure/agreements",
    meta: { title: "Agreement Types – MASH Admin" },
    component: () =>
      import(/* webpackChunkName: "AgreementTypes" */ "../components/admin/configure/AgreementTypes.vue"),
  },
  {
    path: "/admin/configure/general-questions",
    meta: { title: "General Questions – MASH Admin" },
    component: () =>
      import(/* webpackChunkName: "ConfigureGeneralQuestions" */ "../components/admin/configure/GeneralQuestions.vue"),
  },
  {
    path: "/admin/configure/requirements",
    meta: { title: "Requirements Criteria – MASH Admin" },
    component: () =>
      import(/* webpackChunkName: "RequirementsCriteria" */ "../components/admin/configure/RequirementsCriteria.vue"),
  },
  {
    path: "/admin/configure/assignment-staff",
    meta: { title: "Ownership Configuration – MASH Admin" },
    component: () =>
      import(/* webpackChunkName: "AssignmentStaff" */ "../components/admin/configure/AssignmentStaff.vue"),
  },
  {
    path: "/admin/audit/add-drop",
    meta: { title: "Audit: Add/Drop – MASH Admin" },
    component: () =>
      import(/* webpackChunkName: "AuditAddDrop" */ "../views/admin/audit/AuditAddDrop.vue"),
  },
  {
    path: "/auth",
    meta: { title: "Authentication – MASH" },
    component: () =>
      import(/* webpackChunkName: "AuthPlaceHolder" */ "../components/common/AuthPlaceHolder.vue"),
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// WCAG 2.4.2: update document title on every navigation
router.afterEach((to) => {
  const title = to.meta?.title as string | undefined;
  if (title) document.title = title;
});

export default router;
